import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=0dc10ddd&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
import style1 from "./Schedule.vue?vue&type=style&index=1&id=0dc10ddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc10ddd",
  null
  
)

export default component.exports